<div class="busy-overlay-parent" [ngClass]="isLoading||!appState.isReady?'disabled':''">

    <div *ngIf="isLoading||!appState.isReady" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
    </div>

    <div *fesListView="let filteredBuildings of buildingStages">
        <table class="table table-striped table-bordered table-sm">
            <thead>
                <tr>
                    <th fesSortField="stage">Stage</th>
                    <th fesSortField="market">Region</th>
                    <th fesSortField="id">Building</th>
                    <th fesSortField="commonname">Name</th>
                    <th fesSortField="scheduleRequested" [valueResolver]="monthDayDateResolver">Scout Requested</th>
                    <th fesSortField="scheduler">Scheduler</th>
                    <th fesSortField="scheduledDate" [valueResolver]="monthDayDateResolver">Scout</th>
                    <th fesSortField="scouter">Scouter</th>
                    <th style="text-align: center">
                        <!-- <label for="stage-select">Stage: </label>
                        &nbsp;
                        <select id="stage-select" [(ngModel)]="selectedStage" (ngModelChange)="onStageChange($event)"
                            required>
                            <option *ngFor="let stage of stages" [ngValue]="stage.name">{{stage.name}}</option>
                        </select> -->
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <app-filter-field-config>
                            <input fesFilterField="stage" [value]="activeStage" [mode]="activeStage?'=':'contains'" class="small w-100" />
                        </app-filter-field-config>
                    </td>
                    <td>
                        <input fesFilterField="market" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="id" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="commonname" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="scheduleRequested" [valueResolver]="monthDayDateResolver" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="scheduler" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="scheduledDate" [valueResolver]="monthDayDateResolver" class="small w-100" />
                    </td>
                    <td>
                        <input fesFilterField="scouter" class="small w-100" />
                    </td>
                    <td></td>
                </tr>
                <tr *ngFor="let building of filteredBuildings">
                    <td>{{building.stage}}</td>
                    <td>{{building.market}}</td>
                    <td>{{building.id}}</td>
                    <td>{{building.commonname}}</td>
                    <ng-container *ngIf="building.scheduleRequested == ''; else elseBlock1">
                        <td>
                            <button class="btn btn-info" (click)="createScout(building)" style="width:100%; padding: 1px;">Request Scout</button>
                        </td>
                    </ng-container>
                    <ng-template #elseBlock1>
                        <td class="text-center align-middle status-complete">{{building.scheduleRequested|date:'MM/dd'}}
                        </td>
                    </ng-template>
                    <td>
                        <a (click)="editAssignedScheduler(editAssignedUserTemplate,building)"
                            href="javascript:false;">{{building.scheduler}}</a>
                    </td>
                    <ng-container *ngIf="building.scheduledDate == ''; else elseBlock2">
                        <td>
                        </td>
                    </ng-container>
                    <ng-template #elseBlock2>
                        <td class="text-center align-middle status-complete">{{building.scheduledDate|date:'MM/dd'}}</td>
                    </ng-template>
                    <td>
                        <a (click)="editAssignedTester(editAssignedUserTemplate,building)"
                            href="javascript:false;">{{building.scouter}}</a>
                    </td>
                    <ng-container *ngIf="building.scout != null; else elseBlock3">
                        <td class="text-center align-middle text-nowrap">
                            <div class="flex flex-row">
                                <a class="mr-1" href="javascript:false;" (click)="editScoutTaskModal(building.scout)">edit</a>
                                <div class="btn-group p-0 m-0" dropdown>
                                    <a id="edit-options-btn" href="javascript:false;" behavior="button" dropdownToggle
                                        class="dropdown-toggle" aria-controls="dropdown-edit-options">
                                        <span class="caret"></span>
                                    </a>
                                    <ul style="z-index:9999999;min-width:3rem;" id="dropdown-edit-options" *dropdownMenu
                                        class="p-2 dropdown-menu dropdown-menu-right" role="menu"
                                        aria-labelledby="edit-options-btn">
                                        <li role="menuitem"><button class="btn btn-danger"
                                                (click)="deleteScout(building.scout)">Cancel Scout</button></li>
                                    </ul>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-template #elseBlock3>
                        <td></td>
                    </ng-template>
                </tr>
            </tbody>

        </table>
    </div>
    <a href="javascript:false;" (click)="load()"><i class="fa fa-refresh"></i>&nbsp;Refresh</a>
</div>

<ng-template #editAssignedUserTemplate>
    <div *ngIf="selectedTask">
        <div class="modal-header light-blue-header white">
            <div class="modal-title">
                <h5>{{selectedTask.type|titlecase}} - {{selectedTask.stage}} - {{selectedTask.buildingId}}</h5>
            </div>
            <button type="button" class="close pull-right" aria-label="Close"
                (click)="selectedTask=null;editAssignedUserModal.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <table class="table table-striped table-condensed">
                <tbody>
                    <tr>
                        <th class="text-right">Assigned User:</th>
                        <td>
                            <select [(ngModel)]="selectedUser">
                                <option *ngFor="let user of allUsers" [ngValue]="user">
                                    {{user.firstName + ' ' + user.lastName}}</option>
                            </select>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="modal-footer small">
            <button [disabled]="selectedUser&&(selectedUser._id==selectedTask.assignments.testUserId || selectedUser._id==selectedTask.assignments.scheduleUserId)"
                (click)="saveAssignedUser()" class="btn btn-primary">Save</button>
            <button (click)="selectedTask=null;editAssignedUserModal.hide()" class="btn btn-secondary">Cancel</button>
        </div>
    </div>
</ng-template>